import "../base/_jquery-global";
import "bootstrap-table";

export default function customInit() {
    // Random interior header bg image
    $(document).ready(function () {
        var classes = ["header-1", "header-2", "header-3", "header-4", "header-5"];
        var randomnumber = Math.floor(Math.random() * classes.length);

        if (document.querySelector("body").getAttribute("id") !== "suited-up" && document.querySelector("body").getAttribute("id") !== "dp-booster-club") {
            $("#interior-intro").addClass(classes[randomnumber]);
        } else if (document.querySelector("body").getAttribute("id") == "suited-up") {
            $("#interior-intro").addClass("suited-up-header");
        } else if (document.querySelector("body").getAttribute("id") == "dp-booster-club") {
            $("#interior-intro").addClass("dp-booster-club");
        }
    });

    //Close notification
    $(function () {
        $(".demo-avd__close").click(function () {
            $(".demo-avd").addClass("d-none");
        });
    });
}
